import React from 'react'
import BasicLayout from '../../layouts/BasicLayout'
import SubTitle from '../../components/user/SubTitle';
import { ContactAddProvider } from '../../context/ContactAddProvider';
import ContactAddForm from '../../components/user/ContactAddForm';
import MetaTag from '../../components/user/MetaTag';

function ContactPage() {
    return (
        <BasicLayout>
            <div className="max-w-[1400px] mx-auto px-4 py-8 bg-white p-6">
                <MetaTag
                    title="인테리어 견적 문의 | 더룸 1:1 리모델링 상담"
                    description="인테리어 리모델링, 부분 시공, 확장 공사 견적이 궁금하시다면 더룸에 1:1 상담을 신청해 주세요. 예산과 일정에 맞는 리모델링 방향과 예상 비용을 안내해 드립니다."
                    imgsrc="https://www.theroom.co.kr/assets/logos/og-image.png"
                    url="https://www.theroom.co.kr/contact"
                />
                <SubTitle content={"CONTACT"} />
                <ContactAddProvider>
                    <ContactAddForm />
                </ContactAddProvider>
            </div>
        </BasicLayout>
    );
}

export default ContactPage